import { OmniElement, OmniStyleElement, html, css } from 'omni-ui';

OmniStyleElement.register();

/**
 * @extends OmniElement
 */
export class WinningThoughtleader extends OmniElement {
  /**
   * @property {Object} context - Values passed in from wrapper/router
   * @property {Object} schema - Values passed in from wrapper/router
   */
  static get properties() {
    return {
      context: { type: Object },
      schema: { type: Object },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        omni-tile {
          margin-bottom: 2.413rem;
        }
        .title-wrapper {
          margin-left: 2.286rem;
        }
        omni-tile.module-wrapper::part(body-slot) {
          padding: 2.413rem 2.857rem 1.429rem 0;
        }
      `,
    ];
  }

  /**
   * @returns {html} Rendered HTML for the component
   */
  render() {
    return html` <omni-style>
      <omni-tile class="module-wrapper">
        <div class="title-wrapper">
          <h1 class="title mb-4 is-size-2">
            ${this.schema?.module_title ?? 'Idea Generator'}
          </h1>
          <h2 class="mb-5 is-size-3">
            ${this.schema?.section_one_title ?? 'Winning Thoughtleader'}
          </h2>
          <div class="columns">
            <div class="column">
              <div class="mb-5">
                <textarea
                  class="textarea"
                  name="brand"
                  rows="5"
                  readonly
                  placeholder="Pin a Thoughtleader in the Thoughtleader Module to show here"
                  .value="${this.context.sharedData['/studio/thoughtleader']
                    ?.value?.text ?? ''}"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </omni-tile>
    </omni-style>`;
  }
}

OmniElement.register('winning-thoughtleader', WinningThoughtleader);
